import React from "react";
import { useDispatch } from "react-redux";
import { menuSlice } from "redux/slices/menuSlice";
import { push } from "pages/search/api/filterUrlMaker";
import { AutoCompleteSearchBox } from "pages/search/searchBar/AutoCompleteSearchBox";

export const MenuSearch = () => {
  const dispatch = useDispatch();
  const onSubmit = (e) => {
    e.preventDefault && e.preventDefault();
    dispatch(menuSlice.actions.setShowMenu(false));
    push(undefined, "/Search_Results");
  };

  return (
    <form onSubmit={onSubmit}>
      <AutoCompleteSearchBox
        placeholder={"Company, analyst or keyword..."}
        isSearchButtonsVisible={false}
        onSubmit={onSubmit}
      />
    </form>
  );
};
